import { resources as UserMenu } from "../components/features/UsersMenu";
import { resources as PublicProcurementAct } from "../components/features/PublicProcurementAct";
import { resources as Reports } from "../components/features/Reports";
import { resources as Offices } from "../components/features/Offices";
import { resources as Administration } from "../components/features/Administration";
import { resources as CompetitionGeneral } from "../components/features/CompetitionGeneral";
import { resources as Projects } from "../components/features/Projects";
import { resources as TradeNetwork } from "../components/features/TradeNetwork";
import { resources as VacantPositions } from "../components/features/VacantPositions";
import { resources as News } from "../components/features/News";
import { resources as Auctions } from "../components/features/Auctions";

// cms
import { getPagesResource } from "../components/cms/Pages";
import { getGalleryResource } from "../components/cms/Gallery";

import StyleIcon from "@mui/icons-material/Style";
import MenuIcon from "@mui/icons-material/Menu";
import { getUrlTreesResource } from "components/cms/UrlTrees";

const resources = [
  UserMenu,
  Reports,
  TradeNetwork,
  News,
  VacantPositions,
  PublicProcurementAct,
  Offices,
  Administration,
  Projects,
  CompetitionGeneral,
  Auctions,
  {
    isMenu: true,
    name: "cms",
    title: "CMS",
    icon: <StyleIcon />,
    subMenu: [getPagesResource({ permission: "administrator" }), getGalleryResource({ permission: "administrator" })],
    permission: "administrator",
  },

  {
    isMenu: true,
    name: "navigations",
    title: "Навигации",
    icon: <MenuIcon />,
    subMenu: [
      getUrlTreesResource({ permission: "administrator", treeName: "topmenu", treeType: "topmenu", label: "Топ меню" }),
      getUrlTreesResource({
        permission: "administrator",
        treeName: "navigation",
        treeType: "navigation",
        label: "Навигация",
      }),
      getUrlTreesResource({ permission: "administrator", treeName: "footer", treeType: "footer", label: "Футър" }),
      getUrlTreesResource({
        permission: "administrator",
        treeName: "footer-bottom",
        treeType: "footer",
        label: "Долен футър",
      }),
    ],
    permission: "administrator",
  },
];

export { resources };
